import { render } from "./BaseImg.vue?vue&type=template&id=e6e66502"
import script from "./BaseImg.vue?vue&type=script&lang=js"
export * from "./BaseImg.vue?vue&type=script&lang=js"

import "./BaseImg.vue?vue&type=style&index=0&id=e6e66502&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__